import React, { useState, useEffect } from 'react'
import { Col, Button } from 'reactstrap'
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"
import { StyleRoot } from 'proofpoint-radium'
import { FaPlus } from 'react-icons/fa'
import Frame from 'react-frame-component'
import _ from 'lodash'

import Divs from './components/Divs'
import CreateColumn from './CreateColumn'
import ViewportSizeSelector from './components/ViewportSizeSelector'
import CoreRenderFunction from 'containers/TemplateEditor/core/render'

import Lang from 'Lang/General'

const reorder = ( list, startIndex, endIndex ) => {
  const result = Array.from( list )
  const [removed] = result.splice( startIndex, 1 )
  result.splice( endIndex, 0, removed )
  return result
}

const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? "lightblue" : "transparent"
})

const getItemStyle = (isDragging, draggableStyle, itemStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  // change background colour if dragging
  background: isDragging ? "lightgreen" : itemStyle?.backgroundColor || '' ,
  // styles we need to apply on draggables
  ...draggableStyle
})

const Renderer = props => {
  const [ viewWidth, setViewWidth ] = useState( "100%" )
 
  useEffect( () => {
    if( props.isViewOnly ){
      props.setPreviewMode( true )
    }
  }, [ props.isViewOnly ] )

  const renderEditPanel = () => {
    const onDragEnd = async result => {
      if( !result.destination ) {
        return;
      }
      let tmpDOM = _.cloneDeep( props.dom )
      let tmpReorderColumns = tmpDOM.children[ 0 ].children // columns in row
      tmpReorderColumns = reorder( tmpReorderColumns, result.source.index, result.destination.index )
      tmpDOM.children[ 0 ].children = tmpReorderColumns
      props.updateDom( tmpDOM )
    }

    return (
      <div 
        id='renderer-edit-panel'
        style={{ 
          border: '1px solid #000', 
          marginLeft: '0px', 
          width: '100%',
          height: 'max-content',
          overflowY: 'scroll',
          scrollBehavior: 'smooth',
          padding: '0 15px'
        }} >
        <div
          style={{
            width: '100%',
            height: '100%'
          }}>
          <DragDropContext onDragEnd={ onDragEnd }>
            <Droppable droppableId="droppable">
            {( provided, snapshot ) => (
              <div 
                className="row m-0"
                { ...provided.droppableProps }
                ref={ provided.innerRef }
                style={{ 
                  ...getListStyle( snapshot.isDraggingOver )
                }}>
                <style>{ `.vital-carousel-button-hover-animation:after { content: ''; position: absolute; top: 0; left: 0; width: 0; height: 100%; z-index: 1; opacity: 1; background-color: #ffffff; transition: 0.4s; } \n.vital-carousel-button-hover-animation:hover:after { width: 100%; }\n.vital-carousel-button-hover-animation:hover .vital-carousel-button-text { color: #000000 !important; }\n\n.vital-carousel-bg-effect:after { position: absolute; display: block; width: 100%; height: 100%; background: linear-gradient(to bottom, rgba(0,0,0,0.05) 0%, rgba(0,0,0,0.9) 63%, #000 100%); top: 0; left: 0; opacity: 0.35; content: ''; z-index: 1; }\n\n.launch-button-hover-animation:before { content: ''; position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1; opacity: 0; transform: scale(1,0.5); background-color: #72376b; transition: 0.4s; }\n.launch-button-hover-animation:hover:before { opacity: 1; transform: scale(1); }\n\n.launch-image-hover-animation:after { content: ''; position: absolute; top: -110%; left: -210%; width: 200%; height: 200%; opacity: 0; transform: rotate(30deg); background: linear-gradient(to right, rgba(245,242,241,0.43) 0%, rgba(245,242,241,0.13) 77%, rgba(245,242,241,0.5) 92%, rgba(245,242,241,0) 100%); z-index:2; transition: all 0.3s, opacity 0s; }\n.launch-image-hover-animation:hover:after { opacity: 1; top: -90%; left: -80%;  }\n\n.launch-bottom-up-grid:hover .launch-bottom-up-grid-image { transform: scale(1.25); }\n.launch-bottom-up-grid:hover .launch-bottom-up-grid-textbox { justify-content: center; bottom: 16px !important; }\n.launch-bottom-up-grid:hover .launch-bottom-up-grid-textbox-text { opacity: 1 !important; }\n.launch-bottom-up-grid:hover .launch-bottom-up-grid-textbox-button { opacity: 1 !important; }\n\n.fashion-carousel-slanted-bg:before { content: ''; width: 100%; height: 100%; background-color: rgba(255,255,255,0.8); display: block; z-index: -1; position: absolute; top: 0; left: 0; transform: rotate(-5deg); }\n\n.fashion-carousel-button-animation-lr:before { content: ''; background-color: #842e2e; width: 0; height: 100%; position: absolute; top: 0; left: 0; z-index: 1;  transition: 0.4s; }\n.fashion-carousel-button-animation-lr:hover:before { width: 100%; }\n\n.fashion-carousel-bg-effect:after { position:absolute; display: block; width: 100%; height: 100%; top: 0; left: 0; content: ''; z-index: 1; opacity: 0.6; background-image: url(https://fashion-de.oms-suite.de/assets/themes/fashion_de/assets/images/template/muster4.png); }\n\n.fashion-grid:hover .fashion-grid-image { transform: scale(1.2) !important; } \n.fashion-grid:hover .fashion-grid-description { max-height: 100% !important; }\n\n.fashion-button-hover-animation:before { content: ''; position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1; opacity: 0; transform: scale(0.5,1); background-color: #842e2e; transition: 0.4s; } \n.fashion-button-hover-animation:hover:before { opacity: 1; transform: scale(1); }\n\n.injoy-button-hover-animation:before { content: ''; position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1; opacity: 0; transform: scale(1,0.5); background-color: #004063; transition: 0.4s; }\n.injoy-button-hover-animation:hover:before { opacity: 1; transform: scale(1); }\n\n.injoy-image-hover-animation:after { content: ''; position: absolute; top: -110%; left: -210%; width: 200%; height: 200%; opacity: 0; transform: rotate(30deg); background: linear-gradient(to right, rgba(245,242,241,0.43) 0%, rgba(245,242,241,0.13) 77%, rgba(245,242,241,0.5) 92%, rgba(245,242,241,0) 100%); z-index:2; transition: all 0.3s, opacity 0s; }\n.injoy-image-hover-animation:hover:after { opacity: 1; top: -90%; left: -80%;  }\n.injoy-image-hover-animation:hover div { transform: scale(1.10); }\n\n.injoy-carousel-button-animation-lr:before { content: ''; background-color: #808080; width: 0; height: 100%; position: absolute; top: 0; left: 0; z-index: 1;  transition: 0.4s; }\n.injoy-carousel-button-animation-lr:hover:before { width: 100%; }\n\n.injoy-bottom-up-grid:hover .injoy-bottom-up-grid-image { transform: scale(1.25); }\n.injoy-bottom-up-grid:hover .injoy-bottom-up-grid-textbox { justify-content: center; bottom: 16px !important; }\n.injoy-bottom-up-grid:hover .injoy-bottom-up-grid-textbox-text { opacity: 1 !important; }\n.injoy-bottom-up-grid:hover .injoy-bottom-up-grid-textbox-button { opacity: 1 !important; }\n\n.plus-icon:before { content: ''; position: absolute; background: #252525; top: 0; left: 50%; width: 1px; height: 100%; margin-left: -1px; }\n.plus-icon:after { content: ''; position: absolute; background: #252525; top: 50%; left: 0; width: 100%; height: 1px; margin-left: -1px; }\n\n.minus-icon:before { content: ''; position: absolute; background: #252525; top: 50%; left: 0; width: 100%; height: 1px; margin-left: -1px; } .left-right-animated-button:after { content: ''; position: absolute; top: 0; left: 0; width: 0; height: 100%; z-index: 1; opacity: 1; background-color: #252525; transition: 0.4s; }  .left-right-animated-button:hover:after { width: 100%; } \n.left-right-animated-button:hover div { color: #ffffff !important; }  \n\n.left-right-reverse-animated-button:after { content: ''; position: absolute; top: 0; left: 0; width: 0; height: 100%; z-index: 1; opacity: 1; background-color: #ffffff; transition: 0.4s; }  \n.left-right-reverse-animated-button:hover:after { width: 100%; } \n.left-right-reverse-animated-button:hover div { color: #252525 !important; } \n\n.left-right-animated-button-v2:after { content: ''; position: absolute; top: 0; left: 0; width: 0; height: 100%; z-index: 1; opacity: 1; background-color: #252525; transition: 0.4s; } \n.left-right-animated-button-v2:hover:after { width: 100%; }\n\n.left-right-reverse-animated-button-v2:after { content: ''; position: absolute; top: 0; left: 0; width: 0; height: 100%; z-index: 1; opacity: 1; background-color: #ffffff; transition: 0.4s; } \n.left-right-reverse-animated-button-v2:hover:after { width: 100%; }\n\n.border-top-animated-button:before { content: ''; display: block; position: absolute; top: 100%; left: 0; width: 100%; height: 2px; transform: scale(0.85); background: #252525; transition: all 0.3s ease; }\n.border-top-animated-button:hover:before { transform: scale(1); } \n.border-top-animated-button:after { content: ''; display: block; position: absolute; top: 100%; left: 0; width: 100%; height: 2px; transform: scale(0.85); background: #252525; transition: all 0.3s ease; }\n.border-top-animated-button:hover:after { transform: scale(1); top: 0; } \n \n.animated-important-button:before { content: ''; background-color: #ad0a0a; width: 0; height: 100%; position: absolute; top: 0; left: 0; z-index: 1;  transition: 0.4s; }\n.animated-important-button:hover:before { width: 100%; }\n\n.outline-animated-button:before { content: ''; position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1; opacity: 0; transform: scale(1,0.5); background-color: #808080; transition: 0.4s; }\n.outline-animated-button:hover:before { opacity: 1; transform: scale(1); }\n\n.outline-animated-secondary-button:before { content: ''; position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1; opacity: 0; transform: scale(1,0.5); background-color: #808080; transition: 0.4s; }\n.outline-animated-secondary-button:hover:before { opacity: 1; transform: scale(1); }\n\n.slant-animated-button:before { content: ''; position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1; opacity: 0; transform: scale(0.5,1); background-color: #efefef; transition: 0.4s; } \n.slant-animated-button:hover:before { opacity: 1; transform: scale(1); }\n\n.slant-animated-primary-button:before { content: ''; position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1; opacity: 0; transform: scale(0.5,1); background-color: #454545; transition: 0.4s; } \n.slant-animated-primary-button:hover:before { opacity: 1; transform: scale(1); }\n\n.left-right-reverse-primary-animated-button:hover div {color:#252525;primaryColor:[color];}\n.left-right-reverse-primary-animated-button:after { content: ''; position: absolute; top: 0; left: 0; width: 0; height: 100%; z-index: 1; opacity: 1; background-color: #ffffff; transition: 0.4s; }\n.left-right-reverse-primary-animated-button:hover:after { width: 100%; }` }</style>
                {
                  props.content.map(( item, index ) => {
                    if( item.isFloat ) {
                      return (
                        <div
                          style={{ ...item.style }}
                          className={ item.className }
                          onClick={() => {
                            if( item.isColumnContainer && item.isColumnContainer === true ) {
                              props.updateSelectedColId( item.id )
                              props.updateSelectedCol( item )
                            }
                          }}>
                            <Divs 
                              { ...item } 
                              { ...props }
                              data={ item } />
                        </div>
                      )
                    } else {
                      return (
                        <Draggable key={ item.id } draggableId={ item.id } index={ index }>
                          {( provided, snapshot ) => (
                            <div 
                              ref={ provided.innerRef }
                              { ...provided.draggableProps }
                              { ...provided.dragHandleProps }
                              style={{ 
                                border: props.selectedColId === item.id ? '5px solid #0000ff' : 'none',
                                ...getItemStyle(
                                  snapshot.isDragging,
                                  provided.draggableProps.style,
                                  item.style
                                ),
                                ...item.style
                              }} 
                              className={ item.className }
                              onClick={() => {
                                if( item.isColumnContainer && item.isColumnContainer === true ) {
                                  props.updateSelectedColId( item.id )
                                  props.updateSelectedCol( item )
                                }
                              }}>
                                <Divs 
                                  { ...item } 
                                  { ...props }
                                  provided={ provided }
                                  snapshot={ snapshot }
                                  data={ item } />
                            </div>
                          )}
                        </Draggable>
                      )
                    }
                  })
                }
                { provided.placeholder }
              </div>
            )}
            </Droppable>
          </DragDropContext>
        </div>
      </div>
    )
  }

  const renderPreviewPanel = () => {
    return (
      <Frame
        id={ 'editor-section-renderer' }
        style={{
          width: viewWidth,
          height: '70vh'
        }}
        initialContent={ '<!DOCTYPE html><html><head><link href="/static/ckeditor/content-styles.css" rel="stylesheet"></link><link href="/bootstrap.css" rel="stylesheet"></link><link href="/filepond.min.css" rel="stylesheet"></link></head><body style="overflow-y:scroll;overflow-x:hidden;"><div></div></body></html>' }>
        <StyleRoot>
          <CoreRenderFunction
            item={ props.dom }
            mode={ 'preview' }
            selectedLanguageShortname={ props.selectedLanguage } />
        </StyleRoot>
      </Frame>
    )
  }

  return (
    <Col 
      md={ props.isPreviewMode ? 12: 7 }
      className='mb-2 d-flex flex-column'
      style={{ maxHeight: "70vh" }} >
      <div className='d-flex flex-row mb-2' >
        {
          !props.isViewOnly && (
            <Button
              className="btn-icon mr-2"
              color={ props.isPreviewMode ? "success" : "primary" }
              style={{ whiteSpace: 'nowrap', minWidth: 'fit-content' }}
              onClick={ () => props.setPreviewMode( !props.isPreviewMode ) }>
              { Lang[ props.isPreviewMode ? 'EDITING_MODE' : 'PREVIEW_MODE' ][ props.selectedLanguage ] }
            </Button>
          )
        }
        { 
          props.isPreviewMode ? (
            <ViewportSizeSelector 
              currentWidth={ viewWidth }
              setWidth={ setViewWidth }
            />
          ) : (
            <Button 
              className='w-100 d-flex justify-content-center align-items-center'
              onClick={ () => props.toggleShowCreateColumn( true ) }>
              <FaPlus className='mr-2' />
              { Lang[ 'ADD_NEW_COLUMN' ][ props.selectedLanguage ] }
            </Button>
          )
        }
      </div>
      { props.isPreviewMode ? renderPreviewPanel() : renderEditPanel() }
      <CreateColumn { ...props } />
    </Col>
  )
}

export default Renderer